module.exports = __webpack_public_path__ + "media/styleguide/tmp-icons/arrow-rounded-left-55bb31fc17de243f8688c47f70c76362.svg";